import { AuthConsumerRenderProps, withAuthContext } from "auth/AuthContext";
import { CancelTokenSource } from "axios";
import AutomaticBillingPdfModal from "components/automatic-billiing/AutomaticBillingPdfModal";
import TreatmentErrorView from "components/automatic-billiing/segments/TreatmentErrorView";
import PrintProofListPopup from "components/bill/PrintProofListPopup";
import EditActionButton from "components/EditActionButton";
import CheckBox, { CheckboxSc } from "components/final-form/CheckBox";
import DatePicker from "components/final-form/DatePicker";
import { DropdownOption } from "components/final-form/dropdownUtils";
import ErrorMessage from "components/final-form/ErrorMessage";
import Input from "components/final-form/Input";
import Select from "components/final-form/Select";
import FormButtonsRow from "components/layout/FormButtonsRow";
import FormContainer from "components/layout/FormContainer";
import FormContent from "components/layout/FormContent";
import FormModalContentContainer from "components/layout/FormModalContentContainer";
import PxGrid from "components/layout/PxGrid";
import VirtualizedTable from "components/layout/VirtualizedTable";
import LoaderComponent from "components/LoaderComponent";
import MediDataUploadTableView from "components/medidata-upload/MediDataUploadTableView";
import { FormApi } from "final-form";
import createDecorator from "final-form-calculate";
import moment from "moment";
import React, { Component } from "react";
import { Field, Form as FinalForm, FormRenderProps } from "react-final-form";
import { MessageSourceProps, withMessages } from "react-message-source";
import { RouteComponentProps } from "react-router";
import { Button, Grid, Header, Icon, Modal, Popup, Progress } from "semantic-ui-react";
import {
  billTreatments,
  getAutomaticBillExecutionResult,
  getAutomaticBillExecutionStatus,
  getAutomaticBillingExcelUrl
} from "services/billServices";
import axios from "services/http";
import { getAllMandateBanksByMandateId } from "services/mandateBankServices";
import { getAutomaticBillXmlRequests } from "services/mediDataServices";
import styled from "styled-components";
import { BillPrintOption } from "ts-types/api.enums";
import {
  AutomaticBillingDataDto,
  AutomaticBillingProgressDto,
  AutomaticBillingRequest,
  AutomaticBillingResponse,
  AutomaticBillingSearchResponse,
  AutomaticBillRunSearchData,
  BillXmlRequestDto,
  ConsultationBillingDataDto,
  MandateBankDto,
  TariffDto
} from "ts-types/api.types";
import { numberFormatter } from "utils/fomattingUtils";
import { noop } from "utils/functionUtils";
import { composeValidators, isValueValidNumber, mustBeNumber, mustBePositiveNumber } from "utils/validatorUtils";
import { withRouterWorkaround } from "utils/workaroundUtils";

const StyledFinalFormContainer = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  padding: 1em 1em;
`;

const InstallmentsDisabled = styled.span`
  padding-left: 0.85rem;
  color: #b58105;
`;

const InstallmentsDisabledIcon = styled.span`
  padding-right: 0.275rem;
`;

const InstallmentsDisabledText = styled.span``;

const StyledColumn = styled(Grid.Column)`
  padding: 0 !important;
`;

const StyledTable = styled(VirtualizedTable)`
  .ReactVirtualized__Table__Grid {
    outline: none;
    border: 1px solid rgba(34, 36, 38, .15);
    border-top: none;
    border-radius: 0 0 .28571429rem .28571429rem;
  }

  .ReactVirtualized__Table__row {
    border-left: none;
  }

  .ReactVirtualized__Table__headerColumn {
    height: 100%;
    border-right: 1px solid rgba(34, 36, 38, .15);
    padding-top: 0.85rem;
  }

  .ReactVirtualized__Table__headerColumn:last-child {
    border-right: none;
  }

  .ReactVirtualized__Table__rowColumn {
    height: 100%;
    border-right: 1px solid rgba(34, 36, 38, .15);
    padding-top: 0.85rem;
  }

  .ReactVirtualized__Table__rowColumn:last-child {
    border-right: none;
  }
`;

const StyledSelectedTreatments = styled.span`
  float: right;
  text-align: right;
  font-weight: normal;
  font-size: 14px;

  &.margin-top {
    margin-top: 0.5em;
  }
`;

const TableContainer = styled.div`
  height: 90%;
  min-height: 300px;
`;

const StyledForm = styled.form`
  height: 100%;
`;

const StyledFormContent = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-around;
  margin-bottom: 15px;
  height: 100%;
`;

const StyledContainer = styled.div`

  flex: 1 1 auto;

  .ui.header:not(h1):not(h2):not(h3):not(h4):not(h5):not(h6) {
    font-size: 1.1rem;
    color: #373737;

    &.small {
      font-size: 1.05em;
    }
  }

  &.margin {
    margin-left: 20px;
  }

  .header-description {
    margin-bottom: 0.1rem;
  }

  .header-data {
    margin-top: 0.2rem;
    font-weight: 300;

    & .icon:only-child {
      margin-right: 0;
      vertical-align: 1px;
    }
  }
`;

const FormBottomContent = styled(FormContent)`
  flex: 0 0 auto;
`;

const StyledLabel = styled.div`
  display: inline-block;
  width: 150px;

  &.margin-top {
    margin-top: 10px;
  }
`;

const StyledCell = styled.div`
  text-align: right;
  padding-right: 0.4rem;
`;

const NoBillableTreatments = styled.span`
  color: #b58105;
`;

const NoBillableTreatmentsIcon = styled.span`
  padding-right: 0.275rem;
`;

const BillingResultsDiv = styled.div`
  padding: 15px;

  .error {
    margin-top: 0.5rem;

    .error-text {
      color: darkred;
    }
  }
`;

const BillingProgressDiv = styled.div`
  display: inline-block;
  margin-left: 1.2rem;

  .progress-count-label {
    margin-left: 0.375rem;
  }

  .progress-count {
    display: inline-block;
    width: 10rem;
    margin-left: 0.75rem;

    .ui.progress:last-child {
      margin: 0 0 -0.5rem;
    }
  }
`;

const LeadingGridColumn = styled(Grid.Column)`
  .ui.grid > .row > &.column {
    padding-left: 0.1rem;
  }
`;

const StyledInfoModal = styled(Modal)`
  height: 10vh;
  width: 20vw !important;
`;

const StyledTableModal = styled(Modal)`
  height: 60vh;
  width: 60vw !important;

  & .content {
    height: 100%;

    & .bill-xml-invoices-container {
      display: flex;
      flex-direction: column;
      flex: 1 1 auto;
      margin: 0;
      padding: 0;
      border: none;
      box-shadow: none;
      height: 100%;
    }
  }
`;

const activeRowStyle = {
  background: "#e0e0e0",
  color: "rgba(0,0,0,.87)",
  boxShadow: "0 0 0 rgba(0,0,0,.87) inset"
};

interface ExtendedConsultationBillingDataDto extends ConsultationBillingDataDto {
  selected: boolean
}

interface ExtendedTreatmentData extends AutomaticBillingSearchResponse {
  billable: boolean,
  advancedStatus: boolean,
  installments: boolean,
  days?: number,
  quantity?: number,
  lockedValue: boolean,
  consultations: Array<ExtendedConsultationBillingDataDto>
}

interface FinalFormData {
  treatments: Array<ExtendedTreatmentData>,
  billDate: string,
  mandateBankId: number,
  isDetailed: boolean,
  isExcel: boolean,
  billPrintOption: BillPrintOption
}

interface Props extends MessageSourceProps, AuthConsumerRenderProps, RouteComponentProps {
  treatments: Array<AutomaticBillingSearchResponse>,
  treatmentsLoading: boolean,
  tariffs: Array<TariffDto>,
  treatmentDataId: string,
  automaticBillRunSearchData: AutomaticBillRunSearchData
  setErrorMessage: (errorMessage?: string) => void
}

interface State {
  cancelTokenSource: CancelTokenSource,
  selectedTreatmentIx: number,
  selectedConsultationIx: number,
  formData: Partial<FinalFormData>,
  mandateBanks: Array<DropdownOption>,
  paymentModalOpen: boolean,
  tempTreatment?: ExtendedTreatmentData,
  submitInProgress: boolean,
  automaticBillingPdfModalOpen: boolean,
  automaticBillingInfoModalOpen: boolean,
  automaticBillingXmlInvoicesModalOpen: boolean,
  resultsViewOpen: boolean,
  billingStatus?: AutomaticBillingProgressDto,
  billingResults?: AutomaticBillingResponse,
  savedAutomaticBillingResponses: Array<AutomaticBillingResponse>,
  billPrintOption?: BillPrintOption,
  xmlInvoicesToSend: BillXmlRequestDto[]
}

class AutomaticBillingTablesSegment extends Component<Props, State> {

  private currentDate = moment().format("YYYY-MM-DD");

  constructor(props: Props) {
    super(props);
    const {treatments, options: {workDate}, currentUser, setErrorMessage, getMessage} = props;

    const cancelTokenSource = axios.CancelToken.source();

    const formData: Partial<FinalFormData> = {
      treatments: this.getMappedTreatments(treatments),
      billDate: workDate,
      isDetailed: true,
      isExcel: false
    };

    this.state = {
      cancelTokenSource: cancelTokenSource,
      selectedTreatmentIx: treatments && treatments.length > 0 ? 0 : -1,
      selectedConsultationIx: treatments && treatments.length > 0 && treatments[0].consultations.length > 0 ? 0 : -1,
      formData: formData,
      mandateBanks: [],
      paymentModalOpen: false,
      submitInProgress: false,
      automaticBillingPdfModalOpen: false,
      automaticBillingInfoModalOpen: false,
      automaticBillingXmlInvoicesModalOpen: false,
      resultsViewOpen: false,
      savedAutomaticBillingResponses: [],
      xmlInvoicesToSend: []
    };

    if (currentUser) {

      const {mandateId} = currentUser.userConfig;

      getAllMandateBanksByMandateId(mandateId, cancelTokenSource)
          .then(response => {

            const mappedBanks: Array<DropdownOption> = response.map((mandateBank: MandateBankDto) => ({
              key: mandateBank.id,
              text: `${mandateBank.description}, ${mandateBank.city}, (${mandateBank.bankAccount})`,
              value: mandateBank.id
            }));

            if (mappedBanks.length > 0) {
              this.setState({
                mandateBanks: mappedBanks,
                formData: {...formData, mandateBankId: mappedBanks[0].value}
              })
            }
          })
          .catch(() => {
            setErrorMessage(getMessage("error.general"));
          })
    }
  }

  getMappedTreatments = (treatments: Array<AutomaticBillingSearchResponse>): Array<ExtendedTreatmentData> => {
    return treatments
        .map(treatment => {
          const consultations = treatment.consultations;
          let treatmentPrice = treatment.amount;

          const mappedConsultations: Array<ExtendedConsultationBillingDataDto> = consultations
              .map(consultation => {
                const selectableTreatment = this.currentDate >= consultation.consultationDate;
                if (!selectableTreatment) {
                  treatmentPrice -= consultation.consultationAmount;
                }
                return {
                  ...consultation,
                  selected: !treatment.errors.length && selectableTreatment
                }
              });

          return {
            ...treatment,
            amount: treatmentPrice,
            billable: !treatment.errors.length,
            consultations: mappedConsultations,
            installments: false,
            lockedValue: false,
            advancedStatus: !!treatment.advanceAmount
          }
        });
  };

  componentDidUpdate({treatmentsLoading: prevTreatmentsLoading}: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {

    const {treatmentsLoading, treatments} = this.props;
    const {formData} = this.state;

    if (prevTreatmentsLoading !== treatmentsLoading && !treatmentsLoading) {
      this.setState({
        formData: {
          ...formData,
          treatments: this.getMappedTreatments(treatments)
        },
        selectedTreatmentIx: treatments && treatments.length > 0 ? 0 : -1,
        selectedConsultationIx: treatments && treatments.length > 0 && treatments[0].consultations.length > 0 ? 0 : -1,
        resultsViewOpen: false,
        billingResults: undefined
      })
    }
  }

  highlightTreatment = (treatments: any, index: number) => {

    const treatment = treatments[index];
    const hasErrors = treatment.errors.length;

    if (!hasErrors) {
      this.setState({
        selectedTreatmentIx: index,
        selectedConsultationIx: treatments[index].consultations.length > 0
            ? 0
            : -1
      });
    }
  };

  treatmentDateCellRenderer = (data: any) => <div>{moment(data.rowData.treatmentDate).format("DD.MM.YYYY")}</div>;
  amountCellRenderer = (data: any) => <StyledCell>{numberFormatter.format(data.rowData.amount)}</StyledCell>;
  consultationAmountCellRenderer = (data: any) =>
      <StyledCell>{numberFormatter.format(data.rowData.consultationAmount)}</StyledCell>;

  treatmentsActionsCellRenderer = (treatments: Array<ExtendedTreatmentData>) => (data: any) => {
    const {getMessage} = this.props;
    const treatmentIx = data.rowIndex;

    const treatment = treatments[treatmentIx];
    const hasErrors = treatment.errors.length;
    const invalidConsultations = treatment.consultations.filter(c =>
        this.currentDate < c.consultationDate).length;

    const trigger = <Icon name="warning sign" color="red"/>

    return (
        <React.Fragment>
          {hasErrors || invalidConsultations
              ?
              <>
                <Popup
                    trigger={trigger}
                    popperDependencies={[]}
                    popperModifiers={{
                      preventOverflow: {
                        boundary: document.getElementById("treatmentsMainTable")
                      }
                    }}
                    content={hasErrors
                        ? <TreatmentErrorView errors={treatment.errors}/>
                        : getMessage("automaticBilling.invalidConsultation.errorMessage")
                    }
                    flowing
                    on="hover"
                    // onOpen={() => this.onAnamnesisInfoColumnClick(rowData.bookingId)}
                    // onClose={this.clearQuestionAnswerPairState}
                    size="large"
                    position="right center"
                />
              </>
              : <EditActionButton
                  hoverMessage={getMessage('bill.status.open')}
                  onConfirm={() => this.showBillingOptionsModal(treatments, treatmentIx)}
              />
          }

        </React.Fragment>
    );
  };

  treatmentsRowGetter = (treatments: Array<AutomaticBillingSearchResponse>) => ({index}: any) => {

    if (treatments[index]) {
      Object.assign(treatments[index], {index: index + 1});

      return treatments[index];
    }

    return {
      index: index + 1
    }
  };

  treatmentsRowRenderer = (form: FormApi, treatments: Array<ExtendedTreatmentData>) =>
      ({className, columns, index, key, style, rowData}: any) => {
        const {selectedTreatmentIx} = this.state;
        const a11yProps = {"aria-rowindex": index + 1};

        let styles = {...style, userSelect: "none"};

        if (selectedTreatmentIx === index) {
          styles = {
            ...styles,
            ...activeRowStyle
          }
        }

        if (!rowData.billable) {
          styles = {
            ...styles,
            color: "rgb(198, 198, 203)"
          }
        }

        return (
            <div
                {...a11yProps}
                className={className}
                key={key}
                role="row"
                style={styles}
                onClick={() => this.highlightTreatment(treatments, index)}
                onDoubleClick={() => this.showBillingOptionsModal(treatments, index)}
            >
              {columns}
            </div>
        );
      };

  highlightConsultation = (index: number) => {
    this.setState({
      selectedConsultationIx: index
    });
  };

  selectConsultation = (form: FormApi, values: any, index: number) => {
    const {selectedTreatmentIx} = this.state;
    const {treatments} = values;

    const selectedTreatment = treatments[selectedTreatmentIx];

    if (selectedTreatment && treatments) {

      const consultation = selectedTreatment.consultations[index];

      let modifiedTreatments = [...treatments];

      const modifiedTreatment = modifiedTreatments[selectedTreatmentIx];
      const hasErrors = modifiedTreatment.errors.length;

      if (!hasErrors) {
        const consultationIndex =
            modifiedTreatment.consultations.findIndex((c: ExtendedConsultationBillingDataDto) =>
                c.consultationId === consultation.consultationId);

        if (consultationIndex >= 0 && this.currentDate >= consultation.consultationDate) {
          consultation.selected = !consultation.selected;

          let billAmount = 0;
          let billable = false;

          const selectedConsultations = selectedTreatment.consultations
              .filter((c: ExtendedConsultationBillingDataDto) => c.selected);

          if (selectedConsultations.length) {
            billAmount = selectedConsultations
                .reduce((a: number, c: ExtendedConsultationBillingDataDto) => a + c.consultationAmount, 0);
            billable = true;
          }

          modifiedTreatment.amount = parseFloat(billAmount.toFixed(2));
          modifiedTreatment.billable = billable;

          modifiedTreatment.consultations[consultationIndex] = consultation;

          form.change("treatments", modifiedTreatments);
        }
      }
    }
  };

  selectTreatment = (form: FormApi, values: any, index: number) => {
    const {treatments} = values;

    if (treatments) {

      let modifiedTreatments = [...treatments];
      let modifiedTreatment: ExtendedTreatmentData = modifiedTreatments[index];

      const hasErrors = modifiedTreatment.errors.length;

      if (!hasErrors) {
        const countSelectedConsultations =
            modifiedTreatment.consultations.filter((c: ExtendedConsultationBillingDataDto) => c.selected).length;
        const countSelectableConsultations = modifiedTreatment.consultations
            .filter(c => this.currentDate >= c.consultationDate)
            .length;
        const indeterminate = countSelectedConsultations > 0 &&
            countSelectedConsultations < countSelectableConsultations;
        const noSelectedConsultations = countSelectedConsultations === 0 && countSelectableConsultations > 0;
        const allConsultationsSelected = countSelectableConsultations > 0
            && countSelectedConsultations === countSelectableConsultations;

        let modifiedConsultations: ExtendedConsultationBillingDataDto[] = [];
        if (noSelectedConsultations || indeterminate) {
          let consultations = [...modifiedTreatment.consultations];
          modifiedConsultations = consultations
              .map((c: ExtendedConsultationBillingDataDto) => {
                if (this.currentDate >= c.consultationDate) {
                  return {
                    ...c,
                    selected: true
                  }
                }
                return c;
              });
        }

        if (allConsultationsSelected) {
          let consultations = [...modifiedTreatment.consultations];
          modifiedConsultations = consultations
              .map((c: ExtendedConsultationBillingDataDto) => {
                return {
                  ...c,
                  selected: false
                }
              });
        }

        let treatmentAmount = 0;
        let billable = false;

        treatmentAmount = modifiedConsultations.reduce(
            (sum, consultation) => {
              return consultation.selected
                  ? sum + consultation.consultationAmount
                  : sum
            }, 0);
        billable = treatmentAmount > 0;

        modifiedTreatments[index] = {
          ...modifiedTreatment,
          consultations: modifiedConsultations,
          billable: billable,
          amount: treatmentAmount,
          lockedValue: false
        };

        form.change("treatments", modifiedTreatments);
      }
    }
  };

  consultationDateTimeCellRenderer = (data: any) => {
    const date = moment(data.rowData.consultationDate).format("DD.MM.YYYY");
    const time = moment(data.rowData.consultationTime, "hh:mm:ss").format(moment.HTML5_FMT.TIME);
    return `${date} - ${time}`;
  };

  consultationSelectCellRenderer = (data: any, form: FormApi, values: any) => {

    const {rowData, rowIndex} = data;
    const {selected} = rowData;
    const {treatments} = values;
    const {selectedTreatmentIx} = this.state;
    const selectedTreatment = treatments[selectedTreatmentIx];
    const disableSelection = selectedTreatment.lockedValue
        || this.currentDate < rowData.consultationDate;

    return (
        <CheckboxSc
            checked={selected}
            onChange={() => this.selectConsultation(form, values, rowIndex)}
            disabled={disableSelection}
        />
    )
  };

  treatmentSelectCellRenderer = (data: any, form: FormApi, values: any) => {

    const {rowData, rowIndex} = data;

    const consLength = rowData.consultations.length;
    const selectedConsLength = rowData.consultations
        .filter((c: ExtendedConsultationBillingDataDto) => c.selected).length;
    const countSelectableConsultations = rowData.consultations
        .filter((c: ExtendedConsultationBillingDataDto) => this.currentDate >= c.consultationDate)
        .length;

    const selected = consLength === selectedConsLength;
    const indeterminate = selectedConsLength < consLength && selectedConsLength > 0;

    return (
        <CheckboxSc
            checked={selected}
            indeterminate={indeterminate}
            onChange={() => this.selectTreatment(form, values, rowIndex)}
            disabled={countSelectableConsultations === 0}
        />
    )
  };

  treatmentSelectHeaderColumn = (form: FormApi, values: FinalFormData) => {
    const {treatments = []} = values;
    const countSelectableTreatments = treatments.filter(t => {
      const selectableConsultations = t.consultations.filter(c =>
          this.currentDate >= c.consultationDate);

      return !t.errors.length && selectableConsultations.length > 0
    }).length;

    const countSelectedTreatments =
        treatments.filter(treatment =>
            treatment.consultations.filter(c => c.selected).length > 0).length;
    const indeterminate = countSelectedTreatments > 0 && countSelectedTreatments < countSelectableTreatments;
    const noSelectedTreatments = countSelectedTreatments === 0;
    const allTreatmentsSelected = countSelectedTreatments === countSelectableTreatments;

    return (
        <CheckboxSc
            checked={countSelectedTreatments > 0}
            indeterminate={indeterminate}
            onChange={
              () => {
                let modifiedTreatments = [...treatments];

                if (countSelectableTreatments > 0 && (noSelectedTreatments || indeterminate)) {
                  modifiedTreatments = modifiedTreatments.map(treatment => {
                    const hasErrors = treatment.errors.length;
                    const modifiedConsultations = treatment.consultations
                        .map(c => {
                          const validConsultationDate = this.currentDate >= c.consultationDate;
                          return {
                            ...c,
                            selected: !hasErrors && validConsultationDate
                          }
                        });
                    const treatmentAmount = modifiedConsultations.reduce((a, b) => a + b.consultationAmount, 0);
                    return {
                      ...treatment,
                      consultations: modifiedConsultations,
                      amount: treatmentAmount,
                      billable: !hasErrors,
                      lockedValue: false
                    }
                  })
                }

                if (countSelectableTreatments > 0 && allTreatmentsSelected) {
                  modifiedTreatments = modifiedTreatments.map(treatment => {
                    const modifiedConsultations = treatment.consultations.map(c => {
                      return {...c, selected: false}
                    });
                    return {
                      ...treatment,
                      consultations: modifiedConsultations,
                      amount: 0,
                      billable: false,
                      lockedValue: false
                    }
                  })
                }

                form.change("treatments", modifiedTreatments);
              }
            }
            disabled={countSelectableTreatments === 0}
        />
    );
  };

  consultationSelectHeaderColumn = (form: FormApi, values: FinalFormData) => {
    const {selectedTreatmentIx} = this.state;
    const {treatments = []} = values;

    const selectedTreatment = treatments[selectedTreatmentIx];
    const hasErrors = selectedTreatment && selectedTreatment.errors.length;

    if (selectedTreatment && !hasErrors) {
      const countSelectableConsultations = selectedTreatment.consultations.filter(c =>
          this.currentDate >= c.consultationDate).length;
      const countSelectedConsultations =
          selectedTreatment.consultations.filter((c: ExtendedConsultationBillingDataDto) => c.selected).length;
      const indeterminate = countSelectedConsultations > 0 &&
          countSelectedConsultations < countSelectableConsultations;

      return (
          <CheckboxSc
              checked={countSelectedConsultations > 0}
              indeterminate={indeterminate}
              onChange={
                () => this.selectTreatment(form, values, selectedTreatmentIx)
              }
              disabled={countSelectableConsultations === 0}
          />
      )
    }

    return "";
  };

  consultationsRowGetter = (consultations: Array<ExtendedConsultationBillingDataDto>) => ({index}: any) => {

    if (consultations[index]) {
      Object.assign(consultations[index], {index: index + 1});

      return consultations[index];
    }

    return {
      index: index + 1
    }
  };

  consultationsRowRenderer = (form: FormApi, values: any) => ({className, columns, index, key, style}: any) => {
    const {selectedConsultationIx} = this.state;
    const a11yProps = {"aria-rowindex": index + 1};

    let styles = {...style, userSelect: "none"};

    if (selectedConsultationIx === index) {
      styles = {
        ...styles,
        ...activeRowStyle
      }
    }

    return (
        <div
            {...a11yProps}
            className={className}
            key={key}
            role="row"
            style={styles}
            onClick={() => this.highlightConsultation(index)}
            onDoubleClick={() => this.selectConsultation(form, values, index)}
        >
          {columns}
        </div>
    );
  };


  showBillingOptionsModal = (treatments: Array<ExtendedTreatmentData>, selectedTreatmentIx: number) => {

    const treatment = treatments[selectedTreatmentIx];
    const hasErrors = treatment.errors.length;
    const invalidConsultations = treatment.consultations.filter(c =>
        this.currentDate < c.consultationDate).length;

    if (!hasErrors && invalidConsultations === 0) {
      this.setState({
        paymentModalOpen: true,
        tempTreatment: treatment,
        selectedTreatmentIx: selectedTreatmentIx
      });
    }
  };

  hideBillingOptionsModal = () => {
    this.setState(({}: State) => ({
      paymentModalOpen: false,
      tempTreatment: undefined
    }));
  };

  onOkClicked = (values: Partial<FinalFormData>, form: FormApi) => {
    const {selectedTreatmentIx, tempTreatment} = this.state;

    if (values.treatments) {

      const editTreatment = values.treatments && values.treatments[selectedTreatmentIx];

      let treatments = [...values.treatments];

      if (!editTreatment.advancedStatus) {
        treatments[selectedTreatmentIx].advanceAmount = 0;
      }

      if (!editTreatment.installments) {
        treatments[selectedTreatmentIx].days = undefined;
        treatments[selectedTreatmentIx].quantity = undefined;
      }

      if (editTreatment.amount !== tempTreatment!.amount) {
        treatments[selectedTreatmentIx].lockedValue = true;
      }

      form.change("treatments", treatments);
    }

    this.hideBillingOptionsModal();
  };

  openAutomaticBillingPdfModal = (automaticBillingResponses: Array<AutomaticBillingResponse>) => {
    this.setState({
      automaticBillingPdfModalOpen: true,
      savedAutomaticBillingResponses: automaticBillingResponses
    })
  };

  closeAutomaticBillingPdfModal = () => {
    this.setState({
      automaticBillingPdfModalOpen: false,
      savedAutomaticBillingResponses: []
    });
  };

  closeAutomaticBillingInfoModal = () => {
    this.setState({
      automaticBillingInfoModalOpen: false
    });
  };

  closeAutomaticBillingXmlInvoicesModal = () => {
    this.setState({
      automaticBillingXmlInvoicesModalOpen: false
    });
  };

  cancelBillingOptionsChange = (form: FormApi, values: FinalFormData) => {
    const {tempTreatment, selectedTreatmentIx} = this.state;

    this.hideBillingOptionsModal();

    let treatments = [...values.treatments];
    treatments[selectedTreatmentIx] = tempTreatment!;

    form.change("treatments", treatments);
  };

  billableDecorator = createDecorator({
    field: /^treatments\[.*]\.billable$/,
    updates: (value, name, allValues?: Partial<FinalFormData>) => {
      const {selectedTreatmentIx} = this.state;
      if (allValues) {
        const {treatments = []} = allValues;
        let modifiedTreatments = [...treatments];
        let treatment = modifiedTreatments[selectedTreatmentIx];

        let amount = 0;

        if (value) {

          treatment.consultations.forEach(c => {
            c.selected = true;
            amount += c.consultationAmount;
          });
        } else {
          treatment.consultations.forEach(c => c.selected = false);
          treatment.advancedStatus = false;
          treatment.installments = false;
        }

        treatment.amount = amount;

        return {
          ['treatments']: modifiedTreatments
        };
      }

      return {};
    }
  });

  advanceDecorator = createDecorator({
    field: /^treatments\[.*]\.advancedStatus$/,
    updates: (value, name, allValues?: Partial<FinalFormData>) => {
      const {selectedTreatmentIx} = this.state;
      if (allValues) {
        const {treatments = []} = allValues;
        let modifiedTreatments = [...treatments];
        let treatment = modifiedTreatments[selectedTreatmentIx];

        if (value) {
          treatment.advanceAmount = treatment.advanceAmount ? treatment.advanceAmount : 0;
        }

        return {
          ['treatments']: modifiedTreatments
        };
      }

      return {};
    }
  });

  handleSubmit = async (values: Partial<FinalFormData>) => {

    const {treatments} = values;
    const {setErrorMessage, automaticBillRunSearchData, getMessage} = this.props;

    if (treatments) {
      const {treatmentDataId, currentUser, getMessage} = this.props;
      const {cancelTokenSource} = this.state;

      const isExcel = values.isExcel;

      this.setState({
        billPrintOption: values.billPrintOption
      })

      const automaticBillingRequest: Partial<AutomaticBillingRequest> = {
        billDataId: treatmentDataId,
        bankId: values.mandateBankId,
        billDate: values.billDate,
        userId: currentUser ? currentUser.id : undefined,
        mandateId: currentUser ? currentUser.userConfig.mandateId : undefined,
        isDetailed: values.isDetailed,
        isExcel,
        billPrintOption: values.billPrintOption,
        automaticBillRunSearchData: automaticBillRunSearchData
      };

      const excludeAdvanceAmount =
          automaticBillingRequest.billPrintOption === BillPrintOption.PROOF_LIST
          && !automaticBillingRequest.isDetailed;

      const excludedTreatmentIds: Array<number> = treatments
          .filter(treatment => !treatment.billable)
          .map(treatment => treatment.id);

      const treatmentsToBeBilled: Array<AutomaticBillingDataDto> = treatments
          .filter(treatment => treatment.billable)
          .map(treatment => {

            const excludedConsultationIds = treatment.consultations
                .filter(consultation =>
                    !consultation.selected && this.currentDate < consultation.consultationDate
                )
                .map(consultation => consultation.consultationId);
            const selectedConsultationIds = treatment.consultations
                .filter(consultation => consultation.selected)
                .map(consultation => consultation.consultationId);

            return {
              treatmentId: treatment.id,
              billAmount: treatment.amount,
              billAdvanceAmount: treatment.advancedStatus && !excludeAdvanceAmount ? treatment.advanceAmount : undefined,
              installmentQuantity: treatment.installments ? treatment.quantity : undefined,
              installmentDays: treatment.installments ? treatment.days : undefined,
              excludedConsultationIds: excludedConsultationIds,
              selectedConsultationIds: selectedConsultationIds
            }
          });

      automaticBillingRequest.excludedTreatmentIds = excludedTreatmentIds;
      automaticBillingRequest.treatmentsToBeBilled = treatmentsToBeBilled;

      this.setState({
        submitInProgress: true
      });
      const errors: Array<string> = [];
      this.setState({
        billingStatus: undefined
      });
      await billTreatments(automaticBillingRequest, cancelTokenSource)
          .then(response => {

            const runId = response.runId;
            if (runId) {
              this.trackBillingInProgress(runId, isExcel);
            }

          })
          .catch(() => {
            setErrorMessage(getMessage("error.general"));
          });

      if (errors.length > 0) {
        return {
          error: {
            errorHeader: getMessage("error.xmlGeneration"),
            errorContent: errors
          }
        }
      }
    }
  };

  trackBillingInProgress(runId: string, isExcel: boolean | undefined) {
    getAutomaticBillExecutionStatus(runId, this.state.cancelTokenSource)
        .then(response => {
          const status = response.status;
          if ("IN_PROGRESS" === status) {
            this.setState({billingStatus: response});
            setTimeout(() => this.trackBillingInProgress(runId, isExcel), 5000);
          } else if ("FINISHED" === status) {
            this.showBillingResponse(runId);
          }
        });
  }

  exportAutomaticBillingProoflist = (excelId: string, excelName: string) => {
    const {setErrorMessage, getMessage} = this.props;
    setTimeout(() => {
      try {

        const exportUrl = getAutomaticBillingExcelUrl(excelId, excelName);

        const link = document.createElement('a');
        link.href = window.location.origin + exportUrl;

        const defaultFileName = "temp_response.xlsx";

        link.setAttribute('download', defaultFileName);
        document.body.appendChild(link);
        link.click();
      } catch (e) {
        setErrorMessage(getMessage("error.general"));
        return;
      } finally {
      }
    }, 500);
  }

  openXmlInvoiceMedidataModal = async () => {
    const {billingResults} = this.state;
    if (billingResults && billingResults.run.id) {
      try {
        const xmlInvoicesToSend =
            await getAutomaticBillXmlRequests(billingResults.run.id, this.state.cancelTokenSource);

        this.setState({
          xmlInvoicesToSend,
          automaticBillingXmlInvoicesModalOpen: true
        });
        this.closeAutomaticBillingInfoModal();
      } finally {

      }
    }
  }

  showBillingResponse(runId: string) {

    const {setErrorMessage, getMessage} = this.props;
    const {billPrintOption} = this.state;

    getAutomaticBillExecutionResult(runId, this.state.cancelTokenSource)
        .then(response => {
          if (response.pdfId) {
            let automaticBillingResponses: Array<AutomaticBillingResponse> = [];
            automaticBillingResponses.push(response);

            this.openAutomaticBillingPdfModal(automaticBillingResponses);
          } else if (response.excelId) {
            this.exportAutomaticBillingProoflist(response.excelId, response.excelExportName);
          }

          const billingItems = response.items;

          const automaticBillingInfoModalOpen =
              billingItems.filter(item => item.xmlCreated).length > 0
              && !billPrintOption;

          this.setState({
            resultsViewOpen: true,
            automaticBillingInfoModalOpen,
            billingResults: response
          })
        })
        .catch(() => {
          setErrorMessage(getMessage("error.general"));
        })
        .finally(() => {
          this.setState({
            submitInProgress: false
          });
        });
  }

  render(): React.ReactNode {
    const {getMessage} = this.props;
    const {formData, resultsViewOpen, automaticBillingXmlInvoicesModalOpen} = this.state;

    if (resultsViewOpen) {
      const {
        billingResults,
        automaticBillingPdfModalOpen,
        automaticBillingInfoModalOpen,
        savedAutomaticBillingResponses
      } = this.state;

      const billingItems = billingResults!.items;
      const errorsItems = billingItems.filter(item => item.error);

      const numPrinted = billingItems.filter(item => item.docPrinted).length;
      const numXml = billingItems.filter(item => item.xmlCreated).length;
      const numErrors = errorsItems.length;
      const errorMessage = billingResults!.errorMessage;

      return (
          <BillingResultsDiv>
            <div>
              <div>{getMessage("automaticBilling.printedInvoices")}: {numPrinted}</div>
              <div>{getMessage("automaticBilling.xmlInvoices")}: {numXml}</div>
              <div>{getMessage("automaticBilling.skippedTreatments")}: {numErrors}</div>
              {
                  errorMessage &&
                  <div className="error-tex">{errorMessage}</div>
              }
            </div>
            {
              errorsItems.map(errorItem => (
                  <div key={`error-${errorItem.treatmentId}`} className="error">
                    <span>{getMessage("treatment")} ID: {errorItem.treatmentId}</span>
                    <div className="error-text">{errorItem.xmlError}</div>
                  </div>
              ))
            }
            {automaticBillingInfoModalOpen && this.renderAutomaticBillingInfoModal(numXml)}
            {automaticBillingXmlInvoicesModalOpen && this.renderAutomaticBillingXmlInvoicesModal()}
            {
                automaticBillingPdfModalOpen &&
                <AutomaticBillingPdfModal
                    modalOpen={automaticBillingPdfModalOpen}
                    onCloseModal={this.closeAutomaticBillingPdfModal}
                    automaticBillingResponses={savedAutomaticBillingResponses}
                />
            }
          </BillingResultsDiv>
      )
    }

    return (
        <StyledFinalFormContainer>
          <FinalForm
              onSubmit={this.handleSubmit}
              initialValues={formData}
              decorators={[this.billableDecorator, this.advanceDecorator]}
              subscription={{values: true, pristine: true, submitting: true, hasValidationErrors: true}}
              render={this.renderForm}
          />
        </StyledFinalFormContainer>
    )
  };

  renderForm = ({handleSubmit, submitting, values, form, hasValidationErrors}: FormRenderProps): React.ReactNode => {

    const {
      selectedTreatmentIx, mandateBanks, paymentModalOpen, submitInProgress, billingStatus
    } = this.state;

    const {treatments} = values;
    const {treatmentsLoading, getMessage} = this.props;

    const disableBillBtn = !(treatments.filter((treatment: ExtendedTreatmentData) => treatment.billable).length > 0);
    const billableWarning = treatments.length > 0 && disableBillBtn;

    const countSelectableTreatments = treatments.filter((t: ExtendedTreatmentData) => !t.errors.length).length;
    const countSelectedTreatments = treatments
        .filter((treatment: ExtendedTreatmentData) =>
            treatment.consultations.filter(c => c.selected).length
        ).length;

    let totalTreatmentsAmount = 0;
    let totalSelectedTreatmentsAmount = 0;

    treatments.forEach((treatment: ExtendedTreatmentData) => {
      const hasErrors = treatment.errors.length;
      if (!hasErrors) {
        const treatmentConsultationsAmount = treatment.consultations
            .filter(c => c.consultationAmount && isValueValidNumber(c.consultationAmount));

        treatmentConsultationsAmount.forEach((consultation: ExtendedConsultationBillingDataDto) => {
          totalTreatmentsAmount += consultation.consultationAmount;
        });
      }
    });

    const filteredTreatments = treatments
        .filter((treatment: ExtendedTreatmentData) =>
            treatment.amount && isValueValidNumber(treatment.amount) && !treatment.errors.length)
    filteredTreatments
        .forEach((treatment: ExtendedTreatmentData) => {
          totalSelectedTreatmentsAmount += treatment.amount;
        })

    const displaySelectedAmount =
        `${numberFormatter.format(totalSelectedTreatmentsAmount)} ${getMessage("procedureType.CHF")}`;
    const displayAmount =
        `${numberFormatter.format(totalTreatmentsAmount)} ${getMessage("procedureType.CHF")}`;

    const billingProgressFinalizing = billingStatus
        && billingStatus.processedTreatments === billingStatus.totalTreatments;

    const selectedTreatment = treatments[selectedTreatmentIx];

    return (
        <StyledForm onSubmit={handleSubmit}>
          <FormContainer>
            <FormContent>
              <Field
                  name="error"
                  component={ErrorMessage}
              />
              <StyledFormContent>
                <StyledContainer style={{width: "35%"}}>
                  {billableWarning &&
                      <NoBillableTreatments>
                        <NoBillableTreatmentsIcon>
                          <Icon name="exclamation triangle" aria-hidden="true"/>
                        </NoBillableTreatmentsIcon>
                        Please select one or more treatments to be billed
                      </NoBillableTreatments>
                  }
                  <Header>
                    {getMessage("collectiveBill.dueTreatment")}
                    {!!countSelectableTreatments &&
                        <StyledSelectedTreatments>
                          {`${getMessage("automaticBilling.selectedTreatments")}: ${countSelectedTreatments} / ${countSelectableTreatments} ( ${displaySelectedAmount} / ${displayAmount} )`}
                        </StyledSelectedTreatments>
                    }
                  </Header>
                  <TableContainer id="treatmentsMainTable">
                    {treatmentsLoading
                        ? <LoaderComponent
                            message={`${getMessage("loading")} ${getMessage("treatments").toLowerCase()}`}/>
                        : this.renderTreatmentsTable(form, values, treatments)}
                  </TableContainer>
                </StyledContainer>
                <StyledContainer style={{width: "25%", maxWidth: "335px"}} className="margin">
                  <Header>
                    {getMessage("consultations")}
                  </Header>
                  <TableContainer>
                    {selectedTreatment && selectedTreatment.consultations.length > 0
                        ? this.renderConsultationsTable(form, values, selectedTreatment.consultations)
                        : this.renderConsultationsTable(form, values, [])
                    }
                  </TableContainer>
                </StyledContainer>
                <StyledContainer style={{width: "25%"}} className="margin">
                  <Header>
                    {getMessage("bill.information")}
                  </Header>
                  <Header as="h4">
                    <StyledLabel>{getMessage("bill.type.normal")}:</StyledLabel>
                    {selectedTreatment &&
                        numberFormatter.format(selectedTreatment.amount)
                    }
                    {selectedTreatment && selectedTreatment.installments &&
                        <span>
                        &emsp;&emsp;{selectedTreatment.quantity} / {selectedTreatment.days}
                    </span>
                    }
                  </Header>
                  <Header as="h4">
                    <StyledLabel>
                      {getMessage("bill.advancePayment")}:
                    </StyledLabel>
                    {selectedTreatment
                        && selectedTreatment.advancedStatus
                        && selectedTreatment.advanceAmount}
                  </Header>
                  <Header className={"header-description"}>
                    {getMessage("patient")}
                  </Header>
                  {selectedTreatment &&
                      <Header as="h4" className={"header-data"}>
                        <span>
                          {
                              selectedTreatment.id &&
                              <span title={`${getMessage("patient.externalId")}: ${selectedTreatment.id}`}>
                                {`[${selectedTreatment.id}]`}
                              </span>
                          }
                          {
                              selectedTreatment.externalPatientId &&
                              <span
                                  title={`${getMessage("patient.externalId")}: ${selectedTreatment.externalPatientId}`}>
                                {`, [${selectedTreatment.externalPatientId}]`}
                              </span>
                          }
                          {
                              selectedTreatment.patientAppId &&
                              <span
                                  title={`${getMessage("patient.patientExternalId")}: ${selectedTreatment.patientAppId}`}>
                                , [<Icon name={"mobile alternate"} size={"small"}/>{selectedTreatment.patientAppId}]
                              </span>
                          }
                        </span>
                        <div>
                          {`${selectedTreatment.patientName}, ${selectedTreatment.patientFirstName}`}
                        </div>
                        <div>
                          {`${selectedTreatment.patientCity}, ${selectedTreatment.patientBirthDate}`}
                        </div>
                      </Header>
                  }
                  <Header className={"header-description"}>
                    {getMessage("guarantor")}
                  </Header>
                  {selectedTreatment && selectedTreatment.guarantorDescription &&
                      <Header as="h4" className={"header-data"}>
                        <div>
                          {`${selectedTreatment.guarantorDescription}`}
                        </div>
                        <div>
                          {`${selectedTreatment.guarantorZip}, ${selectedTreatment.guarantorCity}`}
                        </div>
                      </Header>
                  }
                </StyledContainer>
              </StyledFormContent>
            </FormContent>
            <FormBottomContent>
              <PxGrid>
                <Grid.Row>
                  <LeadingGridColumn width={2}>
                    <div className="label">{getMessage("bill.date")}:</div>
                    <Field name="billDate"
                           component={DatePicker}
                    />
                  </LeadingGridColumn>

                  <Grid.Column width={4}>
                    <div className="label">{getMessage("bill.bank")}:</div>
                    <Field
                        name="mandateBankId"
                        component={Select}
                        options={mandateBanks}
                        fluid
                    />
                  </Grid.Column>
                </Grid.Row>
              </PxGrid>
            </FormBottomContent>
            <FormButtonsRow>
              <PrintProofListPopup
                  values={values}
                  form={form}
                  handleSubmit={this.handleSubmit}
                  disabled={submitting || submitInProgress || disableBillBtn}
              />
              <Button compact type="submit" primary disabled={submitting || submitInProgress || disableBillBtn}>
                {getMessage("bill")}
              </Button>
              {
                billingStatus && (submitting || submitInProgress)
                    ? (
                        <BillingProgressDiv>
                          {billingProgressFinalizing && (
                              <span className="progress-label">{getMessage("bill.billingInProgressFinalizing")}</span>
                          )}
                          {!billingProgressFinalizing && (
                              <>
                                <span className="progress-label">{getMessage("bill.billingInProgress")}</span>
                                <span className="progress-count-label">
                                  ({`${billingStatus.processedTreatments} / ${billingStatus.totalTreatments}`})
                                </span>
                              </>
                          )}
                          <div className="progress-count">
                            <Progress
                                color="blue"
                                percent={(billingStatus.processedTreatments / billingStatus.totalTreatments) * 100}
                                active/>
                          </div>
                        </BillingProgressDiv>
                    )
                    : ''
              }
            </FormButtonsRow>
          </FormContainer>
          {paymentModalOpen && this.renderBillingOptionsModal(form, values as FinalFormData, hasValidationErrors)}
        </StyledForm>
    );
  };

  renderTreatmentsTable = (form: FormApi, values: any, treatments: Array<ExtendedTreatmentData>): React.ReactNode => {

    const {getMessage} = this.props;

    return (
        <StyledTable
            rowGetter={this.treatmentsRowGetter(treatments)}
            rowRenderer={this.treatmentsRowRenderer(form, treatments)}
            rowCount={treatments.length}
            columns={[
              {
                width: 30,
                label: this.treatmentSelectHeaderColumn(form, values),
                flexShrink: 0,
                dataKey: "id",
                cellRenderer: (data: any) => this.treatmentSelectCellRenderer(data, form, values)
              },
              {
                width: 200,
                label: getMessage("date"),
                dataKey: "treatmentDate",
                cellRenderer: this.treatmentDateCellRenderer
              },
              {
                width: 200,
                label: getMessage("tariff"),
                dataKey: "tariffDescription"
              },
              {
                width: 150,
                label: getMessage("value"),
                dataKey: "amount",
                cellRenderer: this.amountCellRenderer
              },
              {
                width: 100,
                label: getMessage("diagnosis"),
                dataKey: "diagnosis"
              },
              {
                width: 100,
                label: getMessage("actions"),
                dataKey: "id",
                cellRenderer: this.treatmentsActionsCellRenderer(treatments)
              }
            ]}
        />
    )
  };

  renderConsultationsTable = (form: FormApi, values: any, consultations: Array<ExtendedConsultationBillingDataDto>): React.ReactNode => {

    const {getMessage} = this.props;

    return (
        <StyledTable
            rowGetter={this.consultationsRowGetter(consultations)}
            rowRenderer={this.consultationsRowRenderer(form, values)}
            rowCount={consultations.length}
            columns={[
              {
                width: 30,
                label: this.consultationSelectHeaderColumn(form, values),
                dataKey: "id",
                flexShrink: 0,
                cellRenderer: (data: any) => this.consultationSelectCellRenderer(data, form, values)
              },
              {
                width: 300,
                label: `${getMessage("date")} - ${getMessage("time")}`,
                dataKey: "date",
                cellRenderer: (data: any) => this.consultationDateTimeCellRenderer(data)
              },
              {
                width: 150,
                label: getMessage("value"),
                dataKey: "consultationAmount",
                cellRenderer: this.consultationAmountCellRenderer
              }
            ]}
        />
    )
  };

  renderBillingOptionsModal = (form: FormApi, values: FinalFormData, hasValidationErrors: boolean): React.ReactNode => {

    const {getMessage} = this.props;
    const {selectedTreatmentIx, paymentModalOpen} = this.state;

    const disableField = !values.treatments[selectedTreatmentIx].billable;

    const disableAdvanced = !values.treatments[selectedTreatmentIx].advancedStatus;

    const disableInstallments = values.treatments[selectedTreatmentIx].tarmedTariff;

    const disableInstallmentFields = !values.treatments[selectedTreatmentIx].installments;

    const validConsultations = values.treatments[selectedTreatmentIx].consultations
        .filter(c =>
            this.currentDate >= c.consultationDate
        ).length;

    return (
        <Modal
            open={paymentModalOpen}
            onClose={() => this.cancelBillingOptionsChange(form, values)}
            closeOnDimmerClick={false}
        >
          <Modal.Header>{getMessage("automaticBilling.billingOptions")}</Modal.Header>
          <FormModalContentContainer>
            <FormContainer>
              <FormContent>
                <PxGrid>
                  <Grid.Row>
                    <Grid.Column width={5} verticalAlign="middle">
                      <Field
                          name={`treatments[${selectedTreatmentIx}].billable`}
                          component={CheckBox}
                          label={getMessage(`bill`)}
                          disabled={validConsultations === 0}
                      />
                    </Grid.Column>
                    <Grid.Column width={3} verticalAlign="middle">
                      <Field
                          name={`treatments[${selectedTreatmentIx}].installments`}
                          component={CheckBox}
                          label={getMessage(`bill.installments`)}
                          disabled={disableField || disableInstallments}
                      />
                    </Grid.Column>
                    {
                        disableInstallments &&
                        <StyledColumn width={8} verticalAlign="middle">
                          <InstallmentsDisabled>
                            <InstallmentsDisabledIcon>
                              <Icon name="exclamation triangle" aria-hidden="true"/>
                            </InstallmentsDisabledIcon>
                            <InstallmentsDisabledText>
                              {getMessage("bill.installmentsDisabled")}
                            </InstallmentsDisabledText>
                          </InstallmentsDisabled>
                        </StyledColumn>
                    }
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={2} verticalAlign="middle">
                      {getMessage("amount")}
                    </Grid.Column>
                    <Grid.Column width={3} verticalAlign="middle">
                      <Field
                          name={`treatments[${selectedTreatmentIx}].amount`}
                          component={Input}
                          validate={composeValidators(mustBeNumber, mustBePositiveNumber)}

                          // TODO: enable this field when backend billing with edited value is fixed
                          // disabled={disableField}
                          disabled={true}
                          fluid
                      />
                    </Grid.Column>
                    <Grid.Column width={2} verticalAlign="middle">
                      {getMessage("quantity")}
                    </Grid.Column>
                    <Grid.Column width={3} verticalAlign="middle">
                      <Field
                          name={`treatments[${selectedTreatmentIx}].quantity`}
                          component={Input}
                          validate={composeValidators(mustBeNumber, mustBePositiveNumber)}
                          disabled={disableField || disableInstallments || disableInstallmentFields}
                          fluid
                      />
                    </Grid.Column>
                    <Grid.Column width={2} verticalAlign="middle">
                      {getMessage("bill.days")}
                    </Grid.Column>
                    <Grid.Column width={3} verticalAlign="middle">
                      <Field
                          name={`treatments[${selectedTreatmentIx}].days`}
                          component={Input}
                          validate={composeValidators(mustBeNumber, mustBePositiveNumber)}
                          disabled={disableField || disableInstallments || disableInstallmentFields}
                          fluid
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={6} verticalAlign="middle">
                      <Field
                          name={`treatments[${selectedTreatmentIx}].advancedStatus`}
                          component={CheckBox}
                          label={getMessage(`automaticBilling.billAdvanced`)}
                          disabled={disableField}
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={2} verticalAlign="middle">
                      {getMessage("amount")}
                    </Grid.Column>
                    <Grid.Column width={3} verticalAlign="middle">
                      <Field
                          name={`treatments[${selectedTreatmentIx}].advanceAmount`}
                          component={Input}
                          validate={composeValidators(mustBeNumber, mustBePositiveNumber)}
                          disabled={disableField || disableAdvanced}
                          fluid
                      />
                    </Grid.Column>
                  </Grid.Row>
                </PxGrid>
              </FormContent>

              <FormButtonsRow>
                <Button compact type="button" primary
                        onClick={() => this.onOkClicked(values, form)}
                        disabled={hasValidationErrors}
                >
                  {getMessage("button.ok")}
                </Button>
                <Button compact type="button"
                        onClick={() => this.cancelBillingOptionsChange(form, values)}
                >
                  {getMessage("button.cancel")}
                </Button>
              </FormButtonsRow>
            </FormContainer>
          </FormModalContentContainer>
        </Modal>
    );
  }

  renderAutomaticBillingInfoModal = (numXml: number): React.ReactNode => {

    const {getMessage} = this.props;
    const {automaticBillingInfoModalOpen} = this.state;

    return (
        <StyledInfoModal
            open={automaticBillingInfoModalOpen}
            onClose={() => this.closeAutomaticBillingInfoModal()}
            closeOnDimmerClick={false}
        >
          <Modal.Header>{getMessage("mediData.sendToMediData")}</Modal.Header>
          <Modal.Content>
            <div><strong>{getMessage("automaticBilling.sendXmlInvoices")}</strong></div>
            <div>{getMessage("automaticBilling.xmlInvoices")}: {numXml}</div>
          </Modal.Content>
          <Modal.Actions>
            <Button compact primary type="button"
                    onClick={this.openXmlInvoiceMedidataModal}
            >
              {getMessage("button.yes")}
            </Button>
            <Button compact type="button"
                    onClick={this.closeAutomaticBillingInfoModal}
            >
              {getMessage("button.no")}
            </Button>
          </Modal.Actions>
        </StyledInfoModal>
    );
  }

  renderAutomaticBillingXmlInvoicesModal = (): React.ReactNode => {

    const {getMessage} = this.props;
    const {automaticBillingXmlInvoicesModalOpen, xmlInvoicesToSend} = this.state;

    return (
        <StyledTableModal
            open={automaticBillingXmlInvoicesModalOpen}
            onClose={() => this.closeAutomaticBillingXmlInvoicesModal()}
            closeOnDimmerClick={false}
        >
          <Modal.Header>{getMessage("Medidata")}</Modal.Header>
          <Modal.Content>
            <div className="bill-xml-invoices-container">
              <MediDataUploadTableView
                  key={1}
                  billsKeyInt={1}
                  bills={xmlInvoicesToSend}
                  billsTariffId={1}
                  billsLoading={false}
                  onBillsUpdated={noop}
                  preselectBills={true}
                  onClose={this.closeAutomaticBillingXmlInvoicesModal}
              />
            </div>
          </Modal.Content>
        </StyledTableModal>
    );
  }

}

export default withAuthContext(withRouterWorkaround(withMessages(AutomaticBillingTablesSegment)));
